import loadable from '@loadable/component';

export const IdealhSiteWrapper = loadable(
  () => import(/* webpackChunkName: "idealh-site" */ './IdealhSiteWrapper'),
);
